import { render, staticRenderFns } from "./Presidenti.vue?vue&type=template&id=4093fbb3&"
import script from "./Presidenti.vue?vue&type=script&lang=ts&"
export * from "./Presidenti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports